import React, { Fragment } from "react";
import * as MUI from "@mui/material";
import { ThemeContext } from "../../../../contexts/ThemeContext";
import { Link } from "react-router-dom";

export default function TermsAndConditionsEng() {
  const { mode } = React.useContext(ThemeContext);
  return (
    <Fragment>
      <MUI.Typography variant="h3">Terms and Conditions</MUI.Typography>
      <MUI.Typography variant="h4">Data Protection Policy</MUI.Typography>
      <Fragment>
        <MUI.Stack spacing={4}>
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Introduction").toUpperCase()}
            </MUI.Typography>
            <MUI.Typography>
              We are committed to protecting the privacy and security of your
              personal data in accordance with the General Data Protection
              Regulation (GDPR) (EU Regulation 2016/679). This policy explains
              how we collect, process, and store your personal data when using
              our veterinary clinic management platform. Our goal is to ensure
              transparency and trust, while complying with data protection laws
              and handling your data responsibly and securely.
            </MUI.Typography>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Security Measures").toUpperCase()}
            </MUI.Typography>
            <MUI.Typography>
              We use industry-standard security measures to protect your data,
              including encryption, regular security checks, and strict access
              controls to prevent unauthorized access.
            </MUI.Typography>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("ACCESS TO THE WEBSITE").toUpperCase()}
            </MUI.Typography>
            <MUI.Typography>
              When you open our website, your browser will transmit certain data
              to our web server. The data transfer is done for technical
              reasons, so that we can make the requested information available
              to you. To facilitate your access to the website, the following
              data is collected, stored temporarily and used:
            </MUI.Typography>
            <MUI.List sx={{ listStyleType: "disc" }}>
              <MUI.ListItem sx={{ display: "list-item" }}>
                IP address
              </MUI.ListItem>
              <MUI.ListItem sx={{ display: "list-item" }}>
                Date and time of access
              </MUI.ListItem>
              <MUI.ListItem sx={{ display: "list-item" }}>
                Time zone difference from Greenwich Mean Time (GMT)
              </MUI.ListItem>
              <MUI.ListItem sx={{ display: "list" }}>
                Request content (specific page)
              </MUI.ListItem>
              <MUI.ListItem sx={{ display: "list" }}>
                Access status/HTTP status code
              </MUI.ListItem>
              <MUI.ListItem sx={{ display: "list" }}>
                Amount of data transferred
              </MUI.ListItem>
              <MUI.ListItem sx={{ display: "list" }}>
                Website requesting access
              </MUI.ListItem>
              <MUI.ListItem sx={{ display: "list" }}>
                Browser, language settings, browser version, operating system,
                and interface
              </MUI.ListItem>
            </MUI.List>
            <MUI.Typography>
              Furthermore, to protect our legitimate interests, we store such
              data for a limited time so that we can initiate tracking of
              personal data in the event of or attempt of unauthorized access to
              our servers (Article 6(1)(f) of the General Data Protection
              Regulation).
            </MUI.Typography>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Data we collect").toUpperCase()}
            </MUI.Typography>
            <MUI.Stack spacing={2}>
              <MUI.Typography>
                We collect the following types of data to provide our services:
              </MUI.Typography>
              <MUI.List sx={{ listStyleType: "disc" }}>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Personal data: Name, phone number, email address, and other
                  contact details.
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Pet data: Pet name, species, breed, age, and health data
                  (e.g., vaccination dates, treatments).
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Account data: Usernames, passwords, and settings associated
                  with your account.
                </MUI.ListItem>
              </MUI.List>
              <MUI.Typography>
                This data allows us to provide services such as appointment
                scheduling, managing pet health records and effective
                communication between pet owners and veterinary staff.
              </MUI.Typography>
            </MUI.Stack>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("How we use your data").toUpperCase()}
            </MUI.Typography>
            <MUI.Stack spacing={2}>
              <MUI.Typography>
                We process your data for the following purposes:
              </MUI.Typography>
              <MUI.List sx={{ listStyleType: "disc" }}>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Easier appointment scheduling and reservations.
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Storing and managing pet medical records for continuous
                  treatment.
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Enabling accurate communication between pet owners and
                  veterinary staff.
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Supporting internal tools for clinic business management.
                </MUI.ListItem>
              </MUI.List>
              <MUI.Typography>
                We process your data solely for the purpose of providing and
                improving our services.
              </MUI.Typography>
            </MUI.Stack>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Who has access to your data").toUpperCase()}
            </MUI.Typography>
            <MUI.Stack spacing={2}>
              <MUI.Typography>
                Access to your personal data is limited to authorized personnel:
              </MUI.Typography>
              <MUI.List sx={{ listStyleType: "disc" }}>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Veterinary clinic staff: Employees of a clinic you choose for
                  your pet's treatment. In case of clinic change, the newly
                  selected clinic only has access to new data, while the
                  previous clinic retains historical data on services provided.
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Application administrators: Authorized employees of our
                  company responsible for maintaining and improving the
                  platform.
                </MUI.ListItem>
              </MUI.List>
              <MUI.Typography>
                We do not share your personal data with third parties unless
                required by law or if we integrate external services (e.g., POS
                systems) with your consent.
              </MUI.Typography>
            </MUI.Stack>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Your rights under GDPR").toUpperCase()}
            </MUI.Typography>
            <MUI.Stack spacing={2}>
              <MUI.Typography>
                You have the following rights regarding your data:
              </MUI.Typography>
              <MUI.List sx={{ listStyleType: "disc" }}>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Access: Review all personal data we have about you.
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Correction: Correct inaccurate data.
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Deletion: Request deletion of your data, except for legally
                  required records.
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Data portability: Request a copy of your data in a structured,
                  machine-readable format.
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Withdrawal of consent: Withdraw consent for data processing at
                  any time.
                </MUI.ListItem>
              </MUI.List>
              <MUI.Typography>
                To exercise these rights, contact us at:{" "}
                <Link
                  color="inherit"
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.href = `mailto:${"info@kilobyte.hr"}`;
                  }}
                >
                  info@kilobyte.hr
                </Link>
              </MUI.Typography>
            </MUI.Stack>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Data retention period").toUpperCase()}
            </MUI.Typography>
            <MUI.Stack spacing={2}>
              <MUI.Typography>
                We retain your data as long as your account is active. If you
                delete your account, we delete all associated personal data
                unless it's legally or operationally required. For example,
                treatments related to your pet remain visible to the clinic that
                provided the service.
              </MUI.Typography>
            </MUI.Stack>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("USE OF COOKIES").toUpperCase()}
            </MUI.Typography>
            <MUI.Stack spacing={2}>
              <MUI.Typography>
                CENTAR ZA ZAŠTITU NA RADU uses tools to analyze the use of the
                CENTAR ZA ZAŠTITU NA RADU internet portal and to collect certain
                information about you, thereby gaining insights into the needs
                of our visitors and/or users with the aim of improving the
                quality of our offerings. In this regard, so-called cookies and
                other tools are used.
              </MUI.Typography>
              <MUI.Typography>
                The user and/or visitor can reject or delete cookies through the
                appropriate settings on their computer, using the settings of
                their browser. However, this may result in some functions of the
                CENTAR ZA ZAŠTITU NA RADU internet portal no longer being fully
                usable.
              </MUI.Typography>
              <MUI.Typography>
                The mentioned tools collect and store some technical data,
                including the user's and/or visitor's IP address.
              </MUI.Typography>
            </MUI.Stack>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Third-party services and global use").toUpperCase()}
            </MUI.Typography>
            <MUI.Typography>
              Although we currently operate within the EU, our platform is
              cloud-based, and data may be processed on servers in other
              countries. We ensure that all international data transfers comply
              with GDPR standards. If we integrate third-party services (e.g.,
              POS or analytics), we ensure that these service providers are
              GDPR-compliant and meet our strict privacy standards.
            </MUI.Typography>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("LINKS TO OTHER WEBSITES").toUpperCase()}
            </MUI.Typography>
            <MUI.Typography>
              This website may contain links to other websites operated by other
              organizations with their own specific privacy policies. We draw
              your attention to familiarize yourself with their terms of use and
              privacy policies before providing any personal data, as CENTAR ZA
              ZAŠTITU NA RADU does not take responsibility for these websites or
              the organizations that manage them.
            </MUI.Typography>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Updates to this policy").toUpperCase()}
            </MUI.Typography>
            <MUI.Typography>
              We may update this policy periodically to reflect changes in legal
              requirements or our services. Significant changes will be
              communicated via email or within the application before they take
              effect.
            </MUI.Typography>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Contact information".toUpperCase())}
            </MUI.Typography>
            <MUI.Typography>
              If you have questions, concerns, or complaints related to this
              policy, you can contact us at: Email:{" "}
              <Link
                color="inherit"
                onClick={(e) => {
                  e.preventDefault();
                  window.location.href = `mailto:${"info@kilobyte.hr"}`;
                }}
              >
                info@kilobyte.hr
              </Link>
            </MUI.Typography>
          </MUI.Stack>
        </MUI.Stack>
      </Fragment>
    </Fragment>
  );
}
